





























import { defineComponent } from "@vue/composition-api"
import { useGetters, useState } from "vuex-composition-helpers"
import {useStore} from "vuex-composition-helpers";

import CrumbsComponent from "./CrumbsComponent.vue"
import NavigationButtonComponent from "./NavigationButtonComponent.vue"

declare global {
  interface Window {
    dataLayer: any[]
  }
}

export default defineComponent({
  name: "Navigation",
  components: {
    CrumbsComponent,
    NavigationButtonComponent
  },
  props: {
    showCrumbs: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const store = useStore()
    const { config, currentIndex } = useState(["config", "currentIndex"])
    const { showNavigation } = useGetters(["showNavigation"])

    const pushDataLayerEvent = (interactionType: string, navigationDirection: string) => {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: "content_slider_nav",
        interaction_type: interactionType,
        navigation_direction: navigationDirection
      })
    }

    const doNavigate = (index: number, transition?: string) => {
      store.dispatch("navigate", { index, transition })
    }

    const handleSlideNavigation = (index: number, transition: string, direction: string) => {
      pushDataLayerEvent("slide_direction", direction)
      doNavigate(index, transition)
    }

    const handleCrumbNavigation = (index: number) => {
      pushDataLayerEvent("radio_button", "")
      doNavigate(index)
    }

    return {
      config,
      currentIndex,
      showNavigation,
      handleSlideNavigation,
      handleCrumbNavigation
    }
  }
})
